import React, { FunctionComponent } from 'react';
import { DialogDescription, DialogHeader, DialogTitle } from '@companion-professional/components';
import { CheckupDialogDisplayAndFooter } from '../CheckupDialogComponents';
import { CheckupData } from './CreateQuickCheckup';

interface CopyUrlContentProps {
  checkupData: CheckupData;
}

// CopyUrlContent is the final section of the quick checkup dialog.  It displays the checkup url and allows the user to
// copy it to the clipboard.
export const CopyUrlContent: FunctionComponent<CopyUrlContentProps> = ({ checkupData }) => {
  return (
    <div className="flex flex-col space-y-5">
      <DialogHeader>
        <DialogTitle>Checkup Created</DialogTitle>
        <DialogDescription>
          The quick checkup has been created. You can now share the link below with your client or user your phone's
          camera to scan the QR code.
        </DialogDescription>
      </DialogHeader>
      <CheckupDialogDisplayAndFooter checkupUrl={checkupData.checkupUrl} checkupId={checkupData.checkupId} />
    </div>
  );
};
